import React from 'react';
import { set, map, flow, join, size, reduce } from 'lodash/fp';
import LimitRulesOptionLabel from '../../components/reservations/LimitRulesOptionLabel';

export const composeLimitRulesOptionKey = flow(
  map(({ key, quantity }) => `${key}:${quantity}`),
  join(',')
);

export const composeLimitRulesOptionLabel = map(({ key, quantity }) => (
  <LimitRulesOptionLabel size="xs" key={key}>
    {key}:{quantity}
  </LimitRulesOptionLabel>
));

export const composeItemsLimitRules = reduce((rules, each) => {
  if (!each.limitRules) return rules;
  const key = composeLimitRulesOptionKey(each.limitRules);
  return set(key, each.limitRules, rules);
}, {});

export const composeLimitRulesMap = (limitRules, categories = []) => {
  const categoriesAndItemsRules = reduce(
    (rules, each) => {
      const categoryRules = each.limitRules
        ? { [composeLimitRulesOptionKey(each.limitRules)]: each.limitRules }
        : {};

      if (size(each.items)) {
        return {
          ...rules,
          ...categoryRules,
          ...composeItemsLimitRules(each.items)
        };
      }

      return { ...rules, ...categoryRules };
    },
    {},
    categories
  );

  const picklistRule = limitRules
    ? { [composeLimitRulesOptionKey(limitRules)]: limitRules }
    : {};

  return { ...picklistRule, ...categoriesAndItemsRules };
};

const CreateNewOption = { label: 'Create New', value: 0 };

export const limitRulesMapToOptions = limitRulesMap =>
  Object.keys(limitRulesMap).reduce(
    (options, value) => [
      ...options,
      { label: composeLimitRulesOptionLabel(limitRulesMap[value]), value }
    ],
    [CreateNewOption]
  );
